// import Vue from 'vue'

// initial state
const state = {
  greenViewData: {}
}

// getters
const getters = {
  all: state => state.greenViewData,
  tenants: state => state.greenViewData.tenants,
  organization: state => state.greenViewData.organization
}

// actions
const actions = {

  async fetchGreenViewData ({ commit }) {
    // const res = await Vue.axios.get('/api/??????/')
    const res = {
      status: 200,
      obj: {
        tenants: [
          { name: 'Kund 1', address: 'Gatan 1', usage: 'Kontor' },
          { name: 'Kund 2', address: 'Gatan 1', usage: 'Lager' },
          { name: 'Kund 3', address: 'Gatan 1', usage: 'Lager' },
          { name: 'Kund 4', address: 'Gatan 1', usage: 'Lager' },
          { name: 'Kund 5', address: 'Gatan 3', usage: 'Kontor' },
          { name: 'Kund 6', address: 'Gatan 3', usage: 'Kontor' },
          { name: 'Kund 7', address: 'Gatan 3', usage: 'Lager' },
          { name: 'Kund 8', address: 'Gatan 3', usage: 'Kontor' },
          { name: 'Kund 9', address: 'Gatan 3', usage: 'Lager' }
        ],
        organization: [
          { role: 'Driftchef', name: 'John Doe' },
          { role: 'Arbetsledare', name: 'Jack Doe' },
          { role: 'Driftledare', name: 'Jane Doe' },
          { role: 'Ansvarig', name: 'Joe Doe' }
        ]
      }
    }

    if (res.status === 200) commit('setGreenViewData', res.obj)
  }
}

// mutations
const mutations = {
  setGreenViewData (state, obj) {
    state.greenViewData = obj
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/greenview.js